module.exports = __webpack_public_path__ + "img/US.78c185b6.svg";